// AI Generated Test
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ComplianceService } from '@client/app/blocks/service/compliance/compliance.service';
import { ChangesHistoryHelperService } from '@client/app/pages/global/changes-history/services/changes-history-helper/changes-history-helper.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'changes-history-dashboard-table-policy',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-48">
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-8 col-lg-8">{{'Crawled at' | translate}}</th>
                        <th class="text-right col-4" [ngClass]="{'col-lg-7': domain?.scan?.scan_documents, 'col-lg-8': !domain?.scan?.scan_documents}"><span class="visible-print-block">{{'Pages' | translate}}</span><span class="hidden-print">{{'Pages crawled' | translate}}</span></th>
                        <th class="text-right col-4 col-lg-7" *ngIf="domain?.scan?.scan_documents"><span class="visible-print-block">{{'Documents' | translate}}</span><span class="hidden-print">{{'Documents crawled' | translate}}</span></th>
                        <th class="text-right col-8 col-lg-9">{{'Domain compliance' | translate}}</th>
                        <th class="text-right" [ngClass]="{'col-18 col-lg-10': domain?.scan?.scan_documents, 'col-22 col-lg-16': !domain?.scan?.scan_documents}">{{'Content Policies' | translate}}</th>
                        <th class="text-right col-6 col-lg-7"><span class="visible-print-block">{{'Changes' | translate}}</span><span class="hidden-print">{{'Changes since previous crawl' | translate}}</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let story of historyOutput">
                        <td class="text-v-middle"><user-date [twoLines]="true" [date]="story.post_processing_done_at || story.date"></user-date></td>
                        <td class="text-v-middle text-right">{{story.page_count}}</td>
                        <td class="text-v-middle text-right" *ngIf="domain?.scan?.scan_documents">{{story.documents_count}}</td>
                        <td class="text-right text-v-middle">
                            <table-css-compliance class="donut" *ngIf="story.hasCompliance" [totalCount]="totalCount" [errorCount]="story.error"></table-css-compliance>
                            <span *ngIf="!story.hasCompliance" translate>N/A</span>
                        </td>
                        <td class="text-v-middle text-right">
                            <span class="outer-r-mini" *ngFor="let error of policyErrors; trackBy: trackByIndex"><span class="{{error.icon}}" [ngClass]="error.color"></span><span>{{story[error.attr]}}</span></span>
                        </td>
                        <td class="text-v-middle text-right"
                            [ngClass]="story.changeValueColorClass">
                            <span [ngClass]="story.changeValueIconClass">
                            </span>
                            {{story.changePercentageValue}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `,
})
export class PolicyComponent implements OnInit, OnChanges {
    @Input() history: any;
    @Input() domain: any;

    historyOutput: any[] = [];
    issuesStack: string[] = ['policy_with_required_count', 'policy_with_violations_count'];
    totalCount: number = 100;
    policyErrors: any[] = [];

    constructor (
        private complianceService: ComplianceService,
        private changesHistoryHelperService: ChangesHistoryHelperService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.getPolicyErrorOptions();
    }

    ngOnChanges (): void {
        if (this.history) {
            this.historyOutput = this.prepareHistoryOutput(this.history);
        }
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    private prepareHistoryOutput (history: any[]): any[] {
        const result: any[] = [];
        const len = history.length;
        let story: any;
        let entry: any;

        // for is faster than map
        for (let i = 0; i < len; i += 1) {
            story = history[i];
            entry = {
                id: story.id,
                post_processing_done_at: story.post_processing_done_at,
                date: story.date,
                page_count: this.pipeService.get('monNumber')(story.page_count),
                documents_count: this.pipeService.get('monNumber')(story.documents_count),
                error: this.getError(story),
                changePercentageValue: this.pipeService.get('monNumber')(this.changesHistoryHelperService.getChangePercentageValue(story.id, this.history, this.issuesStack) / 100, '0.[00]%'),
                hasCompliance: this.hasCompliance(story),
                changeValueColorClass: this.changesHistoryHelperService.getChangeValueColorClass(story.id, this.history, this.issuesStack),
                changeValueIconClass: this.changesHistoryHelperService.getChangeValueIconClass(story.id, this.history, this.issuesStack),
                policy_with_required_count: this.pipeService.get('monNumber')(story.policy_with_required_count),
                policy_with_violations_count: this.pipeService.get('monNumber')(story.policy_with_violations_count),
            };
            result.push(entry);
        }

        result.sort((a: any, b: any) => b.id - a.id);

        return result;
    }

    private getPolicyErrorOptions (): void {
        this.policyErrors = [
            {
                icon: 'fas fa-ban',
                attr: 'policy_with_violations_count',
                color: 'text-danger',
            },
            {
                icon: 'fas fa-exclamation-triangle',
                attr: 'policy_with_required_count',
                color: 'text-warning',
            },
        ];
    }

    private hasCompliance (history: any): boolean {
        return this.getError(history) !== null;
    }

    private getError (history: any): any {
        const complianceAr = this.complianceService.policyHistoryCompliance(history);
        return Array.isArray(complianceAr) ? complianceAr[1] : null;
    }
}
